import React, { Component } from "react";
import uuid from "react-uuid";
import { logFirebaseEvent } from "../../../shared/utility";
import FindProviderResultItem from "./Item/FindProviderResultItem";

interface IParentProps {
  onClick: (
    provideId: string,
    npi: string,
    distance: number,
    postalCode: string,
    orgDistance: string,
  ) => void;
  contractStatus:string
  providers: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    isNational:boolean;
    postalCode: string;
    phoneNumber: string;
    providerType: string;
    specialty: string[];
    isContracted: true;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    providerTypeId: number;
    specialtyId: number;
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    finderLabel:string;
    additionalLocationsCount: number;
  }[];
}
type Props = IParentProps;
class FindProviderResult extends Component<Props> {
  componentDidMount(){
    logFirebaseEvent("SearchResults");
  }
  render() {
    const { onClick, providers } = { ...this.props };
    // console.log("providers in provider result", providers);
    return (
      <div className="cardView">
        {providers &&
          providers.map((res) => (
            <FindProviderResultItem
              // key={res.providerId}
              key={uuid()}
              provider={res}
              onClick={onClick}
              style={{}}
            />
          ))}
      </div>
    );
  }
}

export default FindProviderResult;
